import { useTranslation } from 'react-i18next';
import { formatFirstRechargeCountdown } from './useFirstRechargePreview';

export function FirstRechargeBonusBanner({ type, percent, remainingSeconds, showPercent = true }: { type: 'first' | 'daily'; percent: number; remainingSeconds: number; showPercent?: boolean }) {
  const { t } = useTranslation('cinema');
  return (
    <div className="mb-3 flex min-h-10 items-center justify-between gap-2 rounded-lg border border-red-300/25 bg-gradient-to-r from-[#C81D25] via-[#E84250] to-[#FB7185] px-3 py-1.5 text-white shadow-[0_7px_20px_rgba(220,38,38,0.22)] sm:px-3.5">
      <div className="flex min-w-0 items-center gap-2">
        <i className="ri-sparkling-2-fill shrink-0 text-base text-yellow-100" />
        <div className="min-w-0 leading-tight">
          <p className="truncate text-xs font-extrabold sm:text-sm">{t(type === 'first' ? 'cinema_firstRechargeLimitedTitle' : 'cinema_dailyRechargeLimitedTitle')}</p>
          {showPercent && percent > 0 && <p className="truncate text-[10px] font-semibold text-white/80 sm:text-[11px]">{t('cinema_firstRechargeLimitedBonus', { percent })}</p>}
        </div>
      </div>
      <div className="flex shrink-0 items-center gap-1.5 rounded-md bg-black/20 px-2 py-1">
        <i className="ri-time-line text-sm text-yellow-100" />
        <span className="font-mono text-xs font-black tabular-nums text-yellow-50 sm:text-sm">{formatFirstRechargeCountdown(remainingSeconds)}</span>
      </div>
    </div>
  );
}

interface CreditPreviewProps {
  points: number;
  bonusPoints: number;
  show: boolean;
  animating: boolean;
  applied: boolean;
  className?: string;
}

export function FirstRechargeCreditPreview({ points, bonusPoints, show, animating, applied, className = '' }: CreditPreviewProps) {
  const { t } = useTranslation('cinema');
  if (!show) return null;
  const displayedPoints = points + (applied ? bonusPoints : 0);

  return (
    <div className={`relative whitespace-nowrap font-bold text-[#F2B06B] ${className}`}>
      {animating && (
        <span className="pointer-events-none absolute bottom-2 right-5 z-20">
          <span className="animate-ao-coin-fall flex h-5 w-5 items-center justify-center rounded-full bg-amber-400 shadow-[0_0_10px_rgba(255,180,60,0.85)]">
            <i className="ri-coin-line text-[11px] font-black text-background-950" />
          </span>
        </span>
      )}
      <span key={displayedPoints} className={applied ? 'animate-recharge-credit-pop inline-block' : 'inline-block'}>
        {t('cinema_rechargeCredited', { points: displayedPoints })}
      </span>
    </div>
  );
}
